// @flow
import CSSTransition from 'react-transition-group/CSSTransition';
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';
import TransitionGroup from 'react-transition-group/TransitionGroup';

export const TRANSITION_DURATION = 200;
export const TRANSITION_DURATION_TOTAL = TRANSITION_DURATION * 2;

export default styled.div.attrs({
    style: ({ isOn, isCustomRange, rgb }) => ({
        background: isOn && !isCustomRange && rgb ? `rgb(${rgb})` : '#FFFFFF'
    })
})`
    color: ${({ isActive, isVariableColour, theme }) =>
        isActive ? (isVariableColour ? theme.white : theme.black) : theme.mediumGrey};
    font-size: ${props => (props.isSmall ? '1.1em' : '1.8em')};
    align-items: center;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;
    box-shadow: rgb(221, 221, 221) 1px 0px 8px 0px;
    outline: none;
`;

export const StyledTransitionGroup = styled(TransitionGroup)`
    cursor: ${({ isSwitchable }) => (isSwitchable ? 'pointer' : 'default')};
    display: block;
    height: 100%;
    position: relative;
    user-select: none;
    width: 100%;
`;

export const StyledCSSTransition = styled(CSSTransition)`
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
    border-radius: 50%;

    &.flipper__flip-enter {
        opacity: 0.01;
        transform: rotateY(-90deg) scale(0.6, 0.6);
    }

    &.flipper__flip-enter.flipper__flip-enter-active {
        opacity: 1;
        transform: rotateY(0) scale(1, 1);
        transition: opacity ${TRANSITION_DURATION}ms ${TRANSITION_DURATION}ms,
            transform ${TRANSITION_DURATION}ms ${TRANSITION_DURATION}ms;
    }

    &.flipper__flip-exit {
        left: 0;
        opacity: 1;
        position: absolute;
        top: 0;
    }

    &.flipper__flip-exit.flipper__flip-exit-active {
        opacity: 0;
        transition: opacity ${TRANSITION_DURATION}ms, transform ${TRANSITION_DURATION}ms;
        transform: rotateY(90deg) scale(0.6, 0.6);
    }
`;

export const BrightnessFlipperWrapper = styled.div`
    display: block;
    width: 100%;
    height: 100%;
    position: relative;

    & > svg {
        position: relative;
        transform: rotate(-45deg);
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 0;
    }

    & circle {
        position: relative;
        cursor: pointer;
    }

    & circle.hit-area {
        position: relative;
    }
`;

export const FlipperIcon = styled(SVGIcon)`
    height: 3em;
    text-shadow: 1px 0px 8px rgb(221, 221, 221);
    width: 3em;
`;

export const FlipperMessage = styled.span`
    font-size: 0.7em;
    text-shadow: 1px 0px 8px rgb(221, 221, 221);
`;

export const BrightnessFlipperContent = styled.div`
    position: absolute;
    height: 69%;
    width: 69%;
    left: 15.5%;
    top: 15.5%;
    z-index: 1;
    border-radius: 50%;
`;

export const BrightnessFlipperIcon = styled(FlipperIcon)`
    > g {
        fill: ${({ isActive, isVariableColour, theme }) =>
            isActive ? (isVariableColour ? theme.white : theme.mainBrandColor) : theme.offlineGrey};
    }
`;

export const Picker = styled.div`
    height: 100%;
    pointer-events: ${props => (props.isOn ? 'auto' : 'none')};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/flipper/styles.js